<template>
  <div class="v-count">
		<div class="counter">
			<div class="label">
              <slot name="label"></slot>
			</div>
			
			<div class="qty" v-bind:class="{ small: ifSmall, }">
				<span class="minus" @click="minus(type)">—</span>
				<span class="number"><slot name="symbol"></slot>{{num}}</span>
				<span class="plus" @click="plus(type)">+</span>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'v-counter',
  props: ['num','type','ifSmall'],
  methods: {
    plus: function (code) {
      this.$emit('plus',code)
    },
    minus: function (code) {
      this.$emit('minus',code)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
	padding:0;
}

.qty{
	display: inline-block;
}
.qty .minus{
	border: 1px solid #e1e1e1;
	padding: 3px;
	float: left;
	width: 34px;
	height: 34px;
	box-sizing: border-box;
	text-align: center;
	color:#ff7444;
	cursor: pointer;
    line-height: 1.5em;
    font-size: 1em;
	-webkit-border-top-left-radius: 3px;
	-webkit-border-bottom-left-radius: 3px;
	-moz-border-radius-topleft: 3px;
	-moz-border-radius-bottomleft: 3px;
	border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;
}		
.qty .number{
	border-top: 1px solid #e1e1e1;
	float: left;
	padding: 6px;
	border-bottom: 1px solid #e1e1e1;
	height: 34px;
	box-sizing: border-box;
	width: 70px;
	text-align: center;
	font-size: 0.8em;
	line-height:1.5em;
}		
.qty .plus{
	border: 1px solid #e1e1e1;
	padding: 0px 6px;
	float: left;
	box-sizing: border-box;
	height: 34px;
	width: 34px;
	text-align: center;
	color: #ff7444;
	font-size: 1.3em;
    line-height: 1.4em;
	font-weight: 100;
	cursor: pointer;
	-webkit-border-top-right-radius: 3px;
	-webkit-border-bottom-right-radius: 3px;
	-moz-border-radius-topright: 3px;
	-moz-border-radius-bottomright: 3px;
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
}
.qty .plus:active, .qty .minus:active{
	background: #eee;
}
.label{
	display: inline-block;
	font-weight: 100;
	vertical-align: top;
	padding: 5px 10px 0 0;
	color: #444;
}
.counter{
	text-align: center;
	display:flex;
	justify-content:center;
}

.qty.small .minus{
	padding: 4px;
	width: 30px;
	height: 30px;
	font-size: 0.8em;
}		


.qty.small .number{
	padding: 4px;
	height: 30px;
	width: 30px;
}		
.qty.small .plus{
	padding: 2px 4px;
	height: 30px;
	width: 30px;
	font-size: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/counter/index.vue